<div class="cell-container">
    <div class="content"
        [style.text-align]="textAlign"
        [style.font-weight]="fontWeight"
        [style.font-size]="fontSize"
    >{{ value | default:'' }}</div>
</div>